module.exports = __webpack_public_path__ + "static/media/s_v10_15.b5547884.mp3";